import {
  Container,
  Box,
  Grid,
  Button,
  useTheme,
  useMediaQuery,
  Typography,
} from '@mui/material';
import Girl from '@assets/images/GirlCocheSeguro.svg';
import { CustomButton } from '@buttons/CustomButton';

interface Props {
  padding?: number;
  elevation?: number;
  isAbsolute: boolean;
  setShowHaveQuotation: Function;
  setIsHeroAction: Function;
  setIsNewQuotation: Function;
}

export const FindPlans = ({
  setShowHaveQuotation,
  setIsHeroAction,
  setIsNewQuotation,
}: Props) => {
  const { breakpoints } = useTheme();
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isMedium = useMediaQuery(breakpoints.only('lg'));

  const stylesGirlDriving = {
    mobile: {
      width: '100%',
      padding: '0 10.71px',
    },
    tablet: {
      width: '400px',
    },
    desk: {},
  };

  return (
    <Container maxWidth={!isMobile ? 'xl' : !isTablet ? 'sm' : 'md'}>
      <Box
        sx={{ flexGrow: 1 }}
        style={{
          marginTop: 50,
          marginBottom: 50,
        }}
      >
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: isMobile || isTablet ? 'wrap' : 'unset',
          }}
        >
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <div
              style={
                stylesGirlDriving[
                  isMobile ? 'mobile' : isTablet ? 'tablet' : 'desk'
                ]
              }
            >
              <img
                src={Girl}
                alt="girl"
                style={{ width: '100%', objectFit: 'cover' }}
                loading="lazy"
              ></img>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              display={'flex'}
              justifyContent={'flex-start'}
              flexDirection="column"
              width={
                isMedium
                  ? '564px'
                  : !isTablet
                  ? '478px'
                  : isMobile
                  ? '349px'
                  : '688px'
              }
              marginTop={isTablet ? '24px' : 'unset'}
            >
              <Typography
                component="h1"
                sx={{
                  width: isMedium
                    ? '564px'
                    : !isTablet
                    ? '473px'
                    : isMobile
                    ? '349px'
                    : '688px',
                  fontWeight: 700,
                  fontSize: !isTablet ? 40 : !isMobile ? 32 : 20,
                  textAlign: 'center',
                  lineHeight: !isTablet ? '49px' : !isMobile ? '39px' : '24px',
                }}
              >
                ¡En Inter encuentra el seguro de auto perfecto para ti!
              </Typography>
              <Typography
                sx={{
                  width: isMedium
                    ? '564px'
                    : !isTablet
                    ? '472px'
                    : isMobile
                    ? '306px'
                    : '688px',
                  fontWeight: 400,
                  fontSize: !isTablet ? 24 : !isMobile ? 24 : 18,
                  textAlign: 'center',
                  lineHeight: !isTablet ? '39px' : !isMobile ? '29px' : '22px',
                  margin: isTablet ? '24px auto 40px auto' : '60px 0',
                }}
              >
                Con <b>Coche seguro</b> cotizar tu seguro de auto nunca
                había sido tan fácil. Conoce nuestro comparador de seguros y
                elige el plan con las coberturas que mejor se adapten a ti.
              </Typography>
              <Box display="flex" justifyContent="center">
                <CustomButton
                  text={'¡Quiero ver planes!'}
                  onClick={() => {
                    window.scrollTo({
                      top: !isTablet ? 1700 : !isMobile ? 2000 : 2500,
                      left: 0,
                      behavior: 'smooth',
                    });
                  }}
                  color={'primary'}
                  variant={'contained'}
                  style={{
                    height: 48,
                    width: isMobile ? 289 : 382,
                    textTransform: 'uppercase',
                  }}
                />
              </Box>
              <Box display="flex" justifyContent="center">
                <Button
                  onClick={() => {
                    setShowHaveQuotation(true);
                    window.scrollTo({
                      top: !isTablet ? 3450 : !isMobile ? 4150 : 5000,
                      left: 0,
                      behavior: 'smooth',
                    });
                    setIsHeroAction(false);
                    setIsNewQuotation(false);
                  }}
                  color={'primary'}
                  variant={'text'}
                  style={{
                    height: 24,
                    fontWeight: 400,
                    fontSize: 14,
                    marginTop: '23px',
                    textTransform: 'none',
                    textDecoration: 'underline',
                  }}
                >
                  ¿Ya tienes un número de cotización?
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
